// extracted by mini-css-extract-plugin
export var alert = "alert-module--alert--f6807";
export var close = "alert-module--close--1d84b";
export var error = "alert-module--error--475ee";
export var icon = "alert-module--icon--2799b";
export var information = "alert-module--information--906ad";
export var message = "alert-module--message--a57ce";
export var success = "alert-module--success--5dc2e";
export var warning = "alert-module--warning--f9ade";